import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Trophy, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Logo from '@/components/Logo';
import SEOHead from '@/components/SEOHead';

/**
 * Creator Leaderboard — gated on launch behind a "Coming Soon" page until
 * we have enough real, verified-earnings creators to rank honestly.
 *
 * Founder direction (June 2 2026): the leaderboard page must show ONLY
 * "Coming Soon" — no preview ranks, no placeholder rows, no marketing
 * copy, no email-capture field. Plain message, return-home CTA, done.
 * The leaderboard API still exists and can be reintroduced later by
 * restoring the previous implementation from git history.
 */
function CreatorLeaderboard() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505] text-white flex flex-col">
      <SEOHead
        title="Creator Leaderboard - Coming Soon | theailedger.ai"
        description="The theailedger.ai Creator Leaderboard is coming soon."
        path="/leaderboard"
      />

      {/* Header */}
      <header className="border-b border-white/10 backdrop-blur-xl bg-black/60 sticky top-0 z-50">
        <div className="container mx-auto px-4 md:px-8 lg:px-12">
          <div className="flex items-center justify-between h-14 md:h-16">
            <div className="flex items-center gap-3">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => navigate('/')}
                className="h-9 w-9"
                data-testid="back-button"
              >
                <ArrowLeft className="w-5 h-5" />
              </Button>
              <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
                <Logo className="w-6 h-6" color="#00F0FF" />
                <span
                  className="text-lg font-bold tracking-tight"
                  style={{ fontFamily: 'Outfit, sans-serif' }}
                >
                  <span className="text-[#00F0FF]">theailedger</span>
                  <span className="hidden sm:inline text-[#00F0FF]">.ai</span>
                </span>
              </div>
            </div>
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="border-white/20 hover:bg-white/5 rounded-full px-4 h-9 text-sm"
              data-testid="browse-marketplace-btn"
            >
              Browse Marketplace
            </Button>
          </div>
        </div>
      </header>

      {/* Coming Soon body */}
      <main className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="text-center" data-testid="leaderboard-coming-soon">
          <Trophy className="w-12 h-12 text-[#00F0FF]/60 mx-auto mb-6" />
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-black text-white tracking-tight"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="leaderboard-title"
          >
            Coming Soon
          </h1>
        </div>
      </main>
    </div>
  );
}

export default CreatorLeaderboard;
